export default {
  googleAnalyticsId: null,
  pasos: {
    paso1: {
      titulo: "Datos del emprendimiento o comercio de tu cliente",
      subtitulo: "Ingresá los siguientes datos para que podamos contactarlo",
      beneficios: {
        titulo:
          "Recibí asesoramiento personalizado para tu emprendimiento y accedé a beneficios",
        items: [
          {
            titulo: null,
            bullets: [
              "Terminal Lapos <strong>bonificada</strong>.",
              "Cuenta <strong>bonificada</strong> por 12 meses (sólo con la contratación del servicio de adquirencia).",
              "Acreditá el sueldo de tus empleados <strong>con beneficios para vos y tu emprendimiento</strong>.",
              "Seguro Integral de Comercio bonificado por 12 meses."
            ]
          }
        ]
      }
    },
    paso2: {
      titulo: "Datos del emprendimiento o comercio de tu cliente",
      subtitulo: "Ingresá los siguientes datos para que podamos contactarlo",
      copy: "Tipo de actividad que realiza el emprendimiento o comercio"
    },
    paso3: {
      titulo: "Datos de contacto de tu cliente",
      subtitulo: "Ingresá los siguientes datos para que podamos contactarlo",
      copy: "Datos de tu cliente"
    },
    paso4: {
      titulo: "Seleccioná una sucursal",
      subtitulo:
        "Elegí la sucursal en donde tu cliente gestionará sus productos",
      copy: "¿Qué otros productos le interesan a tu cliente?"
    }
  }
};
